module.exports = __webpack_public_path__ + "static/user-research-url-db8b38f1e5cff1180979f53a290eb58d.png";